import React from 'react'
import { Switch, Route } from 'react-router-dom'
import AboutPageSF from '../pages/public/AboutPageSF'
import TermsPageSF from '../pages/public/TermsPageSF'
import PricingPageSF from '../pages/public/PricingPageSF'
import PrivacyPageSF from '../pages/public/PrivacyPageSF'
import SpinnerPageSF from '../pages/common/SpinnerPageSF'
import MessagePageSF from '../pages/common/MessagePageSF'
import VersionPageUI from '../pages/common/VersionPageUI'
import WidgetsPageUI from '../pages/common/WidgetsPageUI'
import GAuthReturnPageSF from '../pages/public/GAuthReturnPageSF'
import FBAuthReturnPageSF from '../pages/public/FBAuthReturnPageSF'
import InviteAcceptPageSF from '../pages/public/InviteAcceptPageSF'
import InviteDeclinePageSF from '../pages/public/InviteDeclinePageSF'
import LinkSocialUserPageSF from '../pages/public/LinkSocialUserPageSF'
import BlockUserNotifPageSF from '../pages/public/BlockUserNotifPageSF'
import SocialUserEmailPageSF from '../pages/public/SocialUserEmailPageSF'
import SignUpWithEmailPageSF from '../pages/public/SignUpWithEmailPageSF'
import SignUpWithPhonePageSF from '../pages/public/SignUpWithPhonePageSF'
import BlockProjectNotifPageSF from '../pages/public/BlockProjectNotifPageSF'
import EmailVerificationPageSF from '../pages/public/EmailVerificationPageSF'
import PasswordHelpStep1PageSF from '../pages/public/PasswordHelpStep1PageSF'
import PasswordHelpStep2PageSF from '../pages/public/PasswordHelpStep2PageSF'
import PinCodeResetPageSF from '../pages/public/PinCodeResetPageSF'

const PublicRouteUI = ({ context }) =>
  <Switch>
    <Route exact path='/pub/about'
      render={() =>
        <AboutPageSF context={context} />
      }
    />

    <Route exact path='/pub/fbauth/return'
      render={() =>
        <FBAuthReturnPageSF context={context} />
      }
    />

    <Route exact path='/pub/gauth/return'
      render={() =>
        <GAuthReturnPageSF context={context} />
      }
    />

    <Route exact path='/pub/link-user'
      render={() =>
        <LinkSocialUserPageSF context={context} />
      }
    />

    <Route exact path='/pub/ecid'
      render={() =>
        <div style={{ margin: '1rem' }}>{context.ecid}<br />{(new Date()).toUTCString()}</div>
      }
    />

    {/* in OAuth flow if user didn't provide email - FB only for now */}
    <Route exact path='/pub/email-required'
      render={() =>
        <SocialUserEmailPageSF context={context} />
      }
    />

    {/* user blocks project-specific email notifications */}
    <Route exact path='/pub/email-block/pu/:projectId/:encryptedUserId'
      render={() =>
        <BlockProjectNotifPageSF context={context} />
      }
    />

    {/* user blocks email notifications */}
    <Route exact path='/pub/email-block/u/:encryptedUserId'
      render={() =>
        <BlockUserNotifPageSF context={context} />
      }
    />

    {/* verification email after sign up or email address change */}
    <Route exact path='/pub/email-verification'
      render={() =>
        <EmailVerificationPageSF context={context} />
      }
    />

    <Route exact path='/pub/invite/accept/au/:accountId/:encryptedUserId'
      render={() =>
        <InviteAcceptPageSF context={context} />
      }
    />

    <Route exact path='/pub/invite/decline/au/:accountId/:encryptedUserId'
      render={() =>
        <InviteDeclinePageSF context={context} />
      }
    />

    <Route exact path='/pub/message'
      render={() =>
        <MessagePageSF context={context} />
      }
    />

    <Route exact path='/pub/password-help'
      render={() =>
        <PasswordHelpStep1PageSF context={context} />
      }
    />

    <Route exact path='/pub/password-reset'
      render={() =>
        <PasswordHelpStep2PageSF context={context} />
      }
    />

    <Route exact path='/pub/pricing'
      render={() =>
        <PricingPageSF context={context} />
      }
    />

    <Route exact path='/pub/pincode-reset'
      render={() =>
        <PinCodeResetPageSF context={context} />
      }
    />

    <Route exact path='/pub/privacy'
      render={() =>
        <PrivacyPageSF context={context} />
      }
    />

    <Route exact path='/pub/signup/e'
      render={() =>
        <SignUpWithEmailPageSF context={context} />
      }
    />

    <Route exact path='/pub/signup/p'
      render={() =>
        <SignUpWithPhonePageSF context={context} />
      }
    />

    <Route exact path='/pub/terms'
      render={() =>
        <TermsPageSF context={context} />
      }
    />

    <Route exact path='/pub/spinner'
      render={() =>
        <SpinnerPageSF context={context} />
      }
    />

    <Route exact path='/pub/version'
      render={() =>
        <VersionPageUI context={context} />
      }
    />

    <Route exact path='/pub/widgets'
      render={() =>
        <WidgetsPageUI context={context} />
      }
    />

  </Switch>

export default PublicRouteUI
